// src/app/features/wizard/shapes/shapes-resolver.service.ts
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ShaclApiService } from './shacl-api.service';
import { catchError } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class ShapesResolverService implements Resolve<any[] | { error: string }> {
  constructor(private api: ShaclApiService) { }

  resolve(): Observable<any[] | { error: string }> {
    return this.api.listShapes().pipe(
      catchError(() => {
        return of({ error: 'Failed to load shapes' });
      })
    );
  }
}
